// extracted by mini-css-extract-plugin
export default {"about":"AboutUs_about__lSHnq","about_text":"AboutUs_about_text__74ufe","btn":"AboutUs_btn__xlVF1"};